// @ts-nocheck
import { Box, Typography } from "@mui/material";

const ContactInformation = ({ contact }) => {
  return (
    <>
      <Box>
        <Typography
          variant="h4"
          sx={{ fontSize: "24px", marginBottom: "12px" }}
        >
          Contact Information
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row",
            border: "1px solid #D175B6",
            padding: "6px 10px",
            borderRadius: "5px",
            marginBottom: "10px",
            color: "#fff",
          }}
        >
          <Typography variant="span" sx={{ fontSize: "16px" }}>
            First Name : {contact?.firstName || "N/A"}
          </Typography>
          <Typography variant="span" sx={{ fontSize: "16px" }}>
            Last Name : {contact?.lastName || "N/A"}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row",
            border: "1px solid #D175B6",
            padding: "6px 10px",
            borderRadius: "5px",
            marginBottom: "10px",
            color: "#fff",
          }}
        >
          <Typography variant="span" sx={{ fontSize: "16px" }}>
            {`Phone: ${contact?.mobile || "N/A"}`}
          </Typography>
          <Typography variant="span">{`Email: ${contact?.email || "N/A"}`}</Typography>
        </Box>
        <Typography
          sx={{
            fontSize: "16px",
            border: "1px solid #D175B6",
            padding: "6px 10px",
            borderRadius: "5px",
            marginBottom: "10px",
            color: "#fff",
          }}
        >
          Company Name : {contact?.company || "N/A"}
        </Typography>
      </Box>
    </>
  );
};

export default ContactInformation;